import { GetterTree } from 'vuex'
import { CacheState } from './types'
import { RootState } from '../../types'

export const getters: GetterTree<CacheState, RootState> = {

}
